import { useMutation } from '@tanstack/react-query';
import {
	postRunReports,
	type IPostRunReportsParams,
} from 'api/resources/runReports';

export const usePostRunReports = () => {
	return useMutation((params: IPostRunReportsParams) => postRunReports(params));
};
